import {
  styled,
  Box,
  TableHead,
  TableCell,
  tableCellClasses,
  TableRow,
} from '@mui/material';

export const PageWrapperStyled = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
})) as typeof Box;

export const HeaderStyled = styled(TableHead)({
  background: 'black',
  color: 'white',
  textAlign: 'center',
}) as typeof TableHead;

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.common.black}`,
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: 'center',
    p: {
      color: 'white !important',
    },
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.common.black}`,
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.grey[200],
  },
}));
